/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import { figmaTokens } from "assets/theme/designTokens";

/** Matches dashboard permanent sidenav width in `examples/Sidenav/SidenavRoot.js`. */
const SIDENAV_WIDTH = 288;

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(SIDENAV_WIDTH),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: {
      width: pxToRem(SIDENAV_WIDTH),
      backgroundColor: figmaTokens.sidebarBg,
      backdropFilter: "none",
      height: "100vh",
      margin: 0,
      borderRadius: 0,
      border: "none",
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
